import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { UserCredentialsCognito } from './user-credentials-cognito';
// import * as CognitoSync from 'aws-sdk/clients/cognitosync';

// require('amazon-cognito-js');

export interface CognitoCallback {
    cognitoCallback(message: string, result: any): void;
}

export interface LoggedInCallback {
    isLoggedIn(message: string, loggedIn: boolean): void;
}

export interface Callback {
    callback(): void;
    callbackWithParam(result: any): void;
}


@Injectable()
export class CognitoUtil {

    // public static _REGION = environment.region;

    // public static _IDENTITY_POOL_ID = environment.identityPoolId;
    // public static _USER_POOL_ID = environment.userPoolId;
    // public static _CLIENT_ID = environment.clientId;


    // userCredentials: UserCredentialsCognito;


    constructor(private appConfig: AppConfig,
    ) {

    }

    // This method takes in a raw jwtToken and uses the global AWS config options to build a
    // CognitoIdentityCredentials object and store it for us. It also returns the object to the caller
    // to avoid unnecessary calls to setCognitoCreds.




    // We only use the Id Token (for the API call) and the Refresh token to refresh the Id token
    // getAccessToken(callback: Callback): void {
    //     if (callback == null) {
    //         throw new Error('CognitoUtil: callback in getAccessToken is null...returning');
    //     }
    //     if (this.getCurrentUser() != null) {
    //         this.getCurrentUser().getSession(function (err, session) {
    //             if (err) {
    //                 console.log('CognitoUtil: Can\'t set the credentials:' + err);
    //                 callback.callbackWithParam(null);
    //             } else {
    //                 if (session.isValid()) {
    //                     callback.callbackWithParam(session.getAccessToken().getJwtToken());
    //                 }
    //             }
    //         });
    //     } else {
    //         callback.callbackWithParam(null);
    //     }
    // }


    // refresh(): void {
    //     this.userCredentials.getCurrentUser().getSession(function (err, session) {
    //         if (err) {
    //             console.log('CognitoUtil: Can\'t set the credentials:' + err);
    //         } else {
    //             if (session.isValid()) {
    //                 console.log('CognitoUtil: refreshed successfully');
    //             } else {
    //                 console.log('CognitoUtil: refreshed but session is still not valid');
    //             }
    //         }
    //     });
    // }

    // getUserAttributes(callback: Callback): void {
    //     if (callback == null) {
    //         throw new Error('CognitoUtil: callback in getUserAttributes is null...returning');
    //     }
    //     if (this.userCredentials.getCurrentUser() != null) {
    //         const currentUser = this.userCredentials.getCurrentUser();
    //         currentUser.getSession(function (err, session) {
    //             if (err) {
    //                 console.log('CognitoUtil: Can\'t get session to retrieve the user attributes:' + err);
    //                 callback.callbackWithParam(null);
    //             }
    //             // else {
    //             //     if (session.isValid()) {
    //             //         var attributeList = [];
    //             //         var attribute = {
    //             //             Name: 'custom:apiUrl',
    //             //             Value: 'http://123.456.789.000/api'
    //             //         }
    //             //         var cognitorAttribute = new CognitoUserAttribute(attribute);
    //             //         attributeList.push(attribute);
    //             //         currentUser.updateAttributes(attributeList, function (err, result) {
    //             //             if (err) {
    //             //                 alert(err);
    //             //                 return;
    //             //             }
    //             //             console.log('Update attribute result: ' + result);
    //             //         });
    //             //         currentUser.getUserAttributes((err, result) => {
    //             //             if (err) {
    //             //                 console.log("CognitoUtil: Can't get the user attributes:" + err);
    //             //                 callback.callbackWithParam(null);
    //             //             }
    //             //             else {
    //             //                 callback.callbackWithParam(result);
    //             //             }
    //             //         });
    //             //     }
    //             // }
    //         });
    //     } else {
    //         callback.callbackWithParam(null);
    //     }
    // }

    // getSyncManagerDataSet(callback: Callback): void {
    //     const AWS2: any = AWS;
    //     const syncManager = new AWS2.CognitoSyncManager();
    //     const dataset = syncManager.openOrCreateDataset('UserPreferences', (err, data) => {
    //         if (err) {
    //             console.log('CognitoUtil: Can\'t get the Sync Manager DataSet:' + err);
    //             callback.callbackWithParam(null);
    //         } else {
    //             callback.callbackWithParam(data);
    //         }
    //     });


    //     // let client  = new CognitoSync();
    //     // client.describeDataset({
    //     //     DatasetName: "UserPreferences",
    //     //     IdentityId: this.getCognitoIdentity(),
    //     //     IdentityPoolId: CognitoUtil._IDENTITY_POOL_ID
    //     // }, (err, data) => {
    //     //     if (err) {
    //     //         console.log("CognitoUtil: Can't get the Sync Manager DataSet:" + err);
    //     //         callback.callbackWithParam(null);
    //     //     }
    //     //     else {
    //     //         callback.callbackWithParam(data);
    //     //     }
    //     // });

    // }



    // async getAccessToken(): Promise<string> {
    //     return this.getJWTToken('ACCESS');
    // }

    // async getIdToken(): Promise<string> {
    //     return this.getJWTToken('ID');
    // }

}
